import { useContext, useEffect, Fragment } from "react";
import { GlobalContext } from "../../context/globalContext";
import * as S from "./styles";
import handleResponsiveScroll from "../../mocks/handleResponsiveScroll";
import InfoSentIcon from "../../assets/icons/InfoSentIcon";

interface ISucessMessage {
  ineligible: boolean;
}

const SuccessMessage = ({ ineligible }: ISucessMessage) => {
  const {
    setResultInformations,
    setShowIneligibleScreen,
    setMonthlyValue,
    setSelectedCity,
    setSelectedState,
    setShowSimulationResult,
  } = useContext(GlobalContext);

  function handleRedoSimulation() {
    setShowIneligibleScreen(false);
    setShowSimulationResult(false);
    setResultInformations(null);
    setSelectedCity(null);
    setMonthlyValue("");
    setSelectedState("");

    setTimeout(() => {
      handleResponsiveScroll(".economySimulation", { desk: -590, mob: -340 });
    }, 300);
  }

  useEffect(() => {
    handleResponsiveScroll(".successMessage", { desk: -500, mob: -150 });
  }, []);

  return (
    <Fragment>
        <S.SuccessMessageRoot>
          <S.SuccessMessageWrapper className="inelegibleSimulation">
            <S.InfoCol>
              {ineligible ? (
                <>
                  <S.MainHeader>
                    {import.meta.env.VITE_APP_BLACK_FRIDAY === "true"
                      ? "BLACK GUD: Condições imperdíveis por tempo limitado."
                      : "Parece que o Mercado Livre de Energia ainda não está disponível para sua empresa."}
                  </S.MainHeader>

                  <S.HeaderText>
                    Acompanhe nossas redes sociais para ficar por dentro de todas
                    as atualizações do setor.
                  </S.HeaderText>

                  <S.RedoSimulation $hideOnMobile={true}>
                    <button
                      onClick={() => handleRedoSimulation()}
                      type="button"
                    >
                      Simular novamente
                    </button>
                  </S.RedoSimulation>
                </>
              ) : (
                <>

              <S.MainHeader>
                Sua empresa pode reduzir custos, ganhar previsibilidade e
                fortalecer o fluxo de caixa.
              </S.MainHeader>

              <S.DiscountText>
                Quer se livrar das bandeiras tarifárias e evitar cobranças mais
                altas nos horários de pico? <br />
                Com a GUD, você migra para o Mercado Livre de Energia sem
                alterar seu padrão de consumo e sem precisar investir.
              </S.DiscountText>




                </>
              )}
            </S.InfoCol>
            <S.SuccessMessageFormCol>
              <S.SuccessMessageFormWrapper>
                {ineligible ? (
                  <>
                    <h2>
                      Obrigado por enviar <br /> suas informações
                    </h2>
                    <p>
                      Caso você se torne elegível, um representante GUD entrará
                      em contato com uma proposta para você!
                    </p>

                    <div
                      style={{
                        alignSelf: "center",
                        width: "8rem",
                        marginTop: "1rem",
                      }}
                    >
                      <InfoSentIcon />
                    </div>

                    <S.RedoSimulationAlt id="btnSimular">
                      <button
                        onClick={() => handleRedoSimulation()}
                        type="button"
                      >
                        Simular novamente
                      </button>
                    </S.RedoSimulationAlt>
                  </>
                ) : (
                  <>
                    <div
                      style={{
                        alignSelf: "flex-start",
                        width: "3.5rem",
                        marginTop: "1rem",
                      }}
                    >
                      <InfoSentIcon />
                    </div>
                    <h2>
                      Recebemos suas <br></br> informações de contato
                    </h2>
                    <p>
                      Caso seja elegível, em até 72 horas um representante GUD
                      entrará em contato com uma proposta para você!
                    </p>
                  </>
                )}
              </S.SuccessMessageFormWrapper>
            </S.SuccessMessageFormCol>
          </S.SuccessMessageWrapper>
        </S.SuccessMessageRoot>
    </Fragment>
  );
};

export default SuccessMessage;
